export const CALENDLY_URL =
  'https://calendly.com/fra-unviaggioelaltro/prima-consulenza-gratuita-di-15-minuti'
export const INSTAGRAM_URL = 'https://www.instagram.com/fra.unviaggioelaltro/'
export const TIKTOK_URL = 'https://www.tiktok.com/@fra.unviaggioelaltro'
export const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61577913936357'

declare global {
  interface Window {
    Calendly?: { initPopupWidget: (options: { url: string }) => void }
  }
}

let calendlyLoading: Promise<void> | null = null

function loadCalendlyWidget(): Promise<void> {
  if (window.Calendly) return Promise.resolve()
  if (!calendlyLoading) {
    calendlyLoading = new Promise((resolve, reject) => {
      const styles = document.createElement('link')
      styles.rel = 'stylesheet'
      styles.href = 'https://assets.calendly.com/assets/external/widget.css'
      document.head.appendChild(styles)

      const script = document.createElement('script')
      script.src = 'https://assets.calendly.com/assets/external/widget.js'
      script.async = true
      script.onload = () => resolve()
      script.onerror = () => reject(new Error('Calendly widget failed to load'))
      document.body.appendChild(script)
    })
  }
  return calendlyLoading
}

export function openCalendlyPopup(event?: { preventDefault: () => void }) {
  event?.preventDefault()
  loadCalendlyWidget()
    .then(() => window.Calendly?.initPopupWidget({ url: CALENDLY_URL }))
    .catch(() => window.open(CALENDLY_URL, '_blank', 'noopener'))
}
